import { Factory } from 'rosie';
import '../conversation_item_factory';

import IdGenerator from '../lib/id_generator';

Factory.define('EmailMessage')
  .attr('type', 'EMAIL')
  .attr('to', [])
  .attr('cc', [])
  .attr('headers', () => {
    return { 'message-id': `<${IdGenerator.newId()}@example.com>` };
  })
  .attr('bodyHtml')
  .attr('bodyPlain', ['bodyPlain', 'bodyHtml'], (bodyPlain, bodyHtml) => {
    return bodyPlain ? bodyPlain : bodyHtml;
  })
  .attr('attachments', ['attachments'], attachments => {
    return attachments ? attachments.map(attachment => Factory.attributes('Attachment', attachment)) : [];
  });

Factory.define('EmailMessageWithDefaults')
  .extend('EmailMessage')
  .attr('from', 'support@example.com')
  .attr('to', ['amber.mendez@ict.com'])
  .attr('cc', ['dr@who.uk'])
  .attr('subject', 'What happened to Buzzsaw?')
  .attr('bodyHtml', '<div>He had to make like a banana and split.</div>')
  .attr('bodyPlain', 'He had to make like a banana and split.')
  .attr('bodyPlainStripped', 'He had to make like a banana and split.')
  .attr('sendStatus', '')
  .attr('recipientStatuses', { 'amber.mendez@ict.com': { status: '' }, 'dr@who.uk': { status: '' } })
  .attr('attachments', ['attachments'], attachments => {
    return attachments ? attachments.map(attachment => Factory.attributes('Attachment', attachment)) : [];
  })
  .attr('headers', () => {
    return { 'message-id': `<${IdGenerator.newId()}@example.com>` };
  });

Factory.define('EmailMessageItem')
  .extend('ConversationItem')
  .attr('content', ['content'], content => Factory.attributes('EmailMessage', content));

Factory.define('EmailMessageItemWithDefaults')
  .extend('ConversationItemWithDefaults')
  .attr('content', ['content'], content => Factory.attributes('EmailMessageWithDefaults', content));

Factory.define('OutgoingEmailMessageItemWithDefaults')
  .extend('EmailMessageItemWithDefaults')
  .attr('initiator', {
    type: 'AGENT',
    id: IdGenerator.newId(),
  });

Factory.define('BouncedEmailMessageItem')
  .extend('OutgoingEmailMessageItemWithDefaults')
  .attr('status', { value: 'UNDELIVERED', detail: 'Email delivery failed after 5 attempts' });
